import { HOST_MAP, A_HOST_MAP, USER_SYSTEM_API_HOST_MAP, USER_SYSTEM_BOSS_API_HOST_MAP, U_API_BASE_MAP, API_BASE_MAP, PUBLIC_URL_MAP, PLATFORM_MAP, DEVICE_TYPE_MAP, USER_SYSTEM_HOST_MAP, ANYWHERE_URL_MAP, JETSO_URL_MAP, ZONE_URL_MAP } from '../config/index.mjs';

const HOST = (env) => HOST_MAP.get(env);
const A_HOST = (env) => A_HOST_MAP.get(env);
const USER_SYSTEM_API_HOST = (env) => USER_SYSTEM_API_HOST_MAP.get(env);
const USER_SYSTEM_BOSS_API_HOST = (env) => USER_SYSTEM_BOSS_API_HOST_MAP.get(env);
const U_API_BASE = (env) => U_API_BASE_MAP.get(env);
const API_BASE = (env) => API_BASE_MAP.get(env);
const PUBLIC_URL = (env) => PUBLIC_URL_MAP.get(env);
const PLATFORM = (env, platform) => platform || PLATFORM_MAP.get(env);
const DEVICE_TYPE = (env) => DEVICE_TYPE_MAP.get(env);
const USER_REGISTRATION = (env, lang) => `${USER_SYSTEM_HOST_MAP.get(env)}/${lang}/registration`;
const USER_MEMBERZONE = (env, lang) => `${USER_SYSTEM_HOST_MAP.get(env)}/${lang}/memberzone`;
const USER_LOGIN = (env, lang) => `${USER_SYSTEM_HOST_MAP.get(env)}/${lang}/login?appType=sg&tp=plain&destUrl=${encodeURIComponent(
  location.href
)}`;
const USER_LOGOUT = (env, lang) => `${USER_SYSTEM_HOST_MAP.get(env)}/${lang}/logout?destUrl=${encodeURIComponent(location.href)}`;
const CUSTOMER_TOKEN = (env) => `${ANYWHERE_URL_MAP.get(env)}/api/customer/token`;
const CUSTOMER_LOGOUT = (env) => `${ANYWHERE_URL_MAP.get(env)}/api/customer/logout`;
const ACCOUNT_INFORMATION = (env, lang) => ({
  url: `${ANYWHERE_URL_MAP.get(env)}/${lang}/tvapp/account_profile`,
  text: { sc: "\u5E10\u6237", tc: "\u5E33\u6236", en: "Account information" }[lang]
});
const ACCOUNT = (env, lang) => ({
  url: `${ANYWHERE_URL_MAP.get(env)}/${lang}/tvapp/account_profile`,
  text: { sc: "\u5E10\u6237", tc: "\u5E33\u6236", en: "Account" }[lang]
});
const ACTIVATE_PURCHASE = (env, lang) => ({
  url: `${ANYWHERE_URL_MAP.get(env)}/${lang}/tvapp/subscription`,
  text: { sc: "\u542F\u52A8 / \u8BA2\u9605", tc: "\u555F\u52D5 / \u8A02\u95B1 ", en: "Activate / Purchase" }[lang]
});
const PAITING = (env, lang) => ({
  url: `${ANYWHERE_URL_MAP.get(env)}/${lang}/tvapp/enterpaircode`,
  text: { sc: "\u914D\u5BF9", tc: "\u914D\u5C0D ", en: "Pairing" }[lang]
});
const JETSO_ORDER = (env, lang) => ({
  url: `${JETSO_URL_MAP.get(env)}/${lang}/account/order`,
  text: { sc: "Jetso \u4EA4\u6613\u8BB0\u5F55", tc: "Jetso \u4EA4\u6613\u8A18\u9304 ", en: "Jetso transaction" }[lang]
});
const ZONE_3_HOME = (env, lang) => `${ZONE_URL_MAP.get(env)}/${lang}/`;
const ZONE_3_ORDER = (env, lang) => ({
  url: `${ZONE_URL_MAP.get(env)}/${lang}/account/order`,
  text: { sc: "3ZONE \u4EA4\u6613\u8BB0\u5F55", tc: "3ZONE \u4EA4\u6613\u8A18\u9304 ", en: "3ZONE Transaction" }[lang]
});
const LOGIN_REGISTER_TEXT = (lang) => ({ sc: "\u767B\u9646 / \u6CE8\u518C", tc: "\u767B\u5165 / \u8A3B\u518A ", en: "Login / Register" })[lang];
const LOGOUT_TEXT = (lang) => ({ sc: "\u767B\u51FA", tc: "\u767B\u51FA ", en: "Logout" })[lang];
const ANYWHERE_URL = (env) => ANYWHERE_URL_MAP.get(env);
const APP_DOWNLOAD_LINKS = () => [
  {
    icon: "/img/app_store_download.svg",
    name: "App Store",
    url: "https://itunes.apple.com/hk/app/tvbanywhere/id1404301815?mt=8"
  },
  {
    icon: "/img/google_play_download.svg",
    name: "Google Play",
    url: "https://play.google.com/store/apps/details?id=com.tvb.ott.overseas.sg"
  },
  {
    icon: "/img/app_gallery_download.svg",
    name: "AppGallery",
    url: "https://appgallery.huawei.com/#/app/C102124967"
  },
  {
    icon: "/img/QRcode.png",
    name: "QrCode",
    url: "javascript:;"
  }
];
const SOCIAL_PLATFORM_LINKS = () => [
  {
    icon: "/img/footer_FB.svg",
    name: "Facebook",
    url: "https://www.facebook.com/tvbanywhere"
  },
  {
    icon: "/img/footer_IG.svg",
    name: "Instagram",
    url: "https://www.instagram.com/tvbanywhere_official/"
  }
];

export { ACCOUNT, ACCOUNT_INFORMATION, ACTIVATE_PURCHASE, ANYWHERE_URL, API_BASE, APP_DOWNLOAD_LINKS, A_HOST, CUSTOMER_LOGOUT, CUSTOMER_TOKEN, DEVICE_TYPE, HOST, JETSO_ORDER, LOGIN_REGISTER_TEXT, LOGOUT_TEXT, PAITING, PLATFORM, PUBLIC_URL, SOCIAL_PLATFORM_LINKS, USER_LOGIN, USER_LOGOUT, USER_MEMBERZONE, USER_REGISTRATION, USER_SYSTEM_API_HOST, USER_SYSTEM_BOSS_API_HOST, U_API_BASE, ZONE_3_HOME, ZONE_3_ORDER };
//# sourceMappingURL=getConstant.mjs.map
